import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';

import { AuthService } from '../service/auth.service';
import { SigninService } from 'src/app/services/authentication/signin.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private user: AuthService, private router: Router, private authService: SigninService) { }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    this.authService.init();
    if (
      Object.keys(this.authService.currentUserValue).length === 0
    ) {
      this.router.navigate(['/authentication/signin']);
      return false;
    }

    if(state.url != '/dashboard/dashboard1'){
      if(!this.authService.hasPermission(state.url, this.authService.currentUserValue.permisos)){
        this.router.navigate(['/dashboard/dashboard1']);
        return false;
      }
    }

    // this.router.navigate(['/authentication/signin']);
    return true;
  }
}
